import angular from 'angular';
import RecipientsListComponent from './recipients-list-component';

export default angular.module('recipients-list', []).component('recipientsList', new RecipientsListComponent());



// WEBPACK FOOTER //
// ./src/modules/message/components/recipients-list/recipients-list-module.js